import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import Toggle from 'components/common/Toggle'
import Icon from 'components/common/Icon'
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed'
import { checkboxIcon } from '../../../utils'
import { uiStore } from '../../../stores/UIStore'

@inject('uiStore', 'selectionStore')
@observer
class UserMarkerfileSheetListItem extends Component {
  constructor (props) {
    super(props)
    this.itemRef = React.createRef()
  }

  componentDidUpdate (prevProps) {
    // scroll newly-selected items into view
    if (
      this.props.selected === true &&
      prevProps.selected === false
    ) {
      if (this.itemRef.current) {
        scrollIntoViewIfNeeded(this.itemRef.current, { centerIfNeeded: true })
      }
    }
  }

  render () {
    const {
      marker,
      markerfile,
      selected
    } = this.props

    return (
      <li
        ref={this.itemRef}
        className={classnames({
          nonexpandable: true,
          disabled: marker.markerfile.exceededLimit && !marker.selected,
          selected
        })}
        id={`marker-markerfile-${marker.id}`}
      >
        <nav className='markerfile-item'>
          <span
            className='name' onClick={() => {
              markerfile.selectedMarker = marker
              uiStore.setBoundsToItem(marker)
            }}
          >
            <Icon id='fa-map-marker' />
            <span
              onMouseOver={() => {
                marker.markerfile.exceededLimit && !marker.selected &&
                (uiStore.openHoverTooltip({
                  text: uiStore.limitErrorMessage(),
                  selector: `#marker-markerfile-${marker.id}`
                }))
              }}
              onMouseLeave={() => uiStore.hideHoverTooltip()}
            >{marker.name}
            </span>
          </span>
          <Toggle
            icon={checkboxIcon(marker.selected)}
            enabled={marker.selected}
            onClick={() => marker.toggleSelected()}
          />
        </nav>
      </li>
    )
  }
}

export default UserMarkerfileSheetListItem
